import React, { useState } from 'react';
import cx from 'classnames';

import { VRM } from '@motorway/mw-highway-code/alpha';
import { filterDataProps } from '@THC/utils/helpers';

import type { VehicleCardProps } from './VehicleCard.types';

import styles from './VehicleCard.module.scss';

export const VehicleCard = (
  {
    badge,
    image,
    showVehicleInfo = true,
    vehicleDetails,
    vrm,
    ...rest
  }: VehicleCardProps,
): React.ReactElement => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const { fuel, make, manufactureYear, mileage, model, transmission } = vehicleDetails || {};

  const vehicleDetailsList = [
    manufactureYear,
    mileage && `${mileage?.toLocaleString()} miles`,
    fuel,
    transmission,
  ].filter((item) => item !== undefined);

  const hasVehicleInfo = vehicleDetails && Object.keys(vehicleDetails).length > 0;

  const displayBadge = (cardBadge: React.ReactNode) => {
    let badgeContent;

    if (typeof cardBadge === 'string') {
      badgeContent = <img src={cardBadge} />;
    } else {
      badgeContent = cardBadge;
    }

    return <div className={cx(styles.vehicleCardBadge, {
      [styles.imageLoaded]: imageLoaded,
    })}>
      {badgeContent}
    </div>;
  };

  return <div
    className={cx(styles.vehicleCard, {
      [styles.infoHidden]: !showVehicleInfo || !hasVehicleInfo,
    })}
    {...filterDataProps(rest)}
    data-cy="vehicleCard"
  >
    {badge && image && displayBadge(badge)}
    <img
      alt='Profile vehicle'
      className={cx(styles.vehicleCardImage, {
        [styles.imageLoaded]: imageLoaded,
      })}
      onLoad={() => setImageLoaded(true)}
      src={image}
    />
    {(!showVehicleInfo || !hasVehicleInfo) && vrm && <span className={styles.vrmOverImage}>
      <VRM size='small' text={vrm} />
    </span>}
    {showVehicleInfo && hasVehicleInfo && <div className={styles.vehcileInfo}>
      {vrm && <VRM size='small' text={vrm} />}

      {make && <h5 className={styles.vehicleMakeModel}>{make} {model}</h5>}

      {vehicleDetailsList.length > 0 && <ul className={styles.vehicleDetails}>
        {vehicleDetailsList.map((detail) => detail && <li key={detail}>{detail}</li>)}
      </ul>}
    </div>}
  </div>;
};
